module.exports = __webpack_public_path__ + "img/sistema-de-ensino.fe2e0567.png";